import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";

import OneGallery from "./OneGallery";

export default function GalleryBanner(props) {

  const appContext = useContext(AppContext);
  const isGalleryPage = (appContext.navItem === "gallery");

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllGallery(),
    ]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <div
        className="MainBodySection bg-light"
        style={{
          paddingBottom: "75px"
        }}
      >
        
        <div className={`container ${isGalleryPage ? "pt-4" : "pt-2"}`}>

          <div className="row">
            	<div className="container py-5" >
                <header>
                  <h2 className="w-header-title text-secondary text-start" style={{ fontSize: "clamp(2.4rem, 6vw, 4.8rem)", fontWeight: 900, lineHeight: 1, letterSpacing: "-0.06em", color: "#fff", fontFamily: "'Inter', system-ui, sans-serif" }}>
                    Gallery
                  </h2>
                </header>
              </div>

            {
              (appContext.allGallery && appContext.allGallery.length > 0)
                ? appContext.allGallery.map((item, i) => (
                    <div key={i} className="col-md-4">
                      <OneGallery data={item} />
                    </div>
                  ))
                : (
                  <div className="col-md-12 mb-1 mt-1">
                    <h6>No data was found</h6>
                  </div>
                )
            }

          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
